/**
 * Kody wartości dokumentu
 *
 * Jeżeli kodu nie ma w tym enumie, to nie wyświetli się w tabeli wartości systemowych
 *
 * @export
 * @enum {number}
 */
export enum DocumentValueCodes {
  ADDRESS_EXPLANATION_DATE = 'ADDRESS_EXPLANATION_DATE',
  AMENDING_DECISION_DATE = 'AMENDING_DECISION_DATE',
  AMENDING_DECISION_NUMBER = 'AMENDING_DECISION_NUMBER',
  APPEAL_CHANGE_FORM_DATE = 'APPEAL_CHANGE_FORM_DATE',
  APPEAL_DATE = 'APPEAL_DATE',
  APPEAL_FOR_HOLD_DATE = 'APPEAL_FOR_HOLD_DATE',
  APPEAL_FOR_RENEWAL_DATE = 'APPEAL_FOR_RENEWAL_DATE',
  APPEAL_PARENT_DECISION_HOLD_DATE = 'APPEAL_PARENT_DECISION_HOLD_DATE',
  APPEAL_SCHOOL_DECISION_WITHDRAWAL_DATE = 'APPEAL_SCHOOL_DECISION_WITHDRAWAL_DATE',
  APPEAL_UNDULY_SCHOLARSHIP_REDEMPTION_DATE = 'APPEAL_UNDULY_SCHOLARSHIP_REDEMPTION_DATE',
  BENEFIT_GRANT_I_INSTANCE_DECISION_DATE_AFTER_APPEAL = 'BENEFIT_GRANT_I_INSTANCE_DECISION_DATE_AFTER_APPEAL',
  BENEFIT_GRANT_I_INSTANCE_DECISION_DATE_AFTER_SKO_DECISION = 'BENEFIT_GRANT_I_INSTANCE_DECISION_DATE_AFTER_SKO_DECISION',
  BENEFIT_GRANT_I_INSTANCE_DECISION_NUMBER_AFTER_APPEAL = 'BENEFIT_GRANT_I_INSTANCE_DECISION_NUMBER_AFTER_APPEAL',
  BENEFIT_GRANT_I_INSTANCE_DECISION_NUMBER_AFTER_SKO_DECISION = 'BENEFIT_GRANT_I_INSTANCE_DECISION_NUMBER_AFTER_SKO_DECISION',
  BENEFIT_GRANT_II_INSTANCE_DECISION_DATE_AFTER_APPEAL = 'BENEFIT_GRANT_II_INSTANCE_DECISION_DATE_AFTER_APPEAL',
  BENEFIT_GRANT_II_INSTANCE_DECISION_NUMBER_AFTER_APPEAL = 'BENEFIT_GRANT_II_INSTANCE_DECISION_NUMBER_AFTER_APPEAL',
  CERTIFICATE_DATE = 'CERTIFICATE_DATE',
  CERTIFICATE_NUMBER = 'CERTIFICATE_NUMBER',
  CHANGE_FORM_DATE = 'CHANGE_FORM_DATE',
  DATE_OF_CONSENT_TO_CHANGE_DECISION = 'DATE_OF_CONSENT_TO_CHANGE_DECISION',
  DATE_OF_NOTIFICATION_ABOUT_LEAVING_WITHOUT_RECOGNITION = 'DATE_OF_NOTIFICATION_ABOUT_LEAVING_WITHOUT_RECOGNITION',
  DATE_OF_NOTIFICATION_ABOUT_PROCEEDING_TERMINATION = 'DATE_OF_NOTIFICATION_ABOUT_PROCEEDING_TERMINATION',
  DATE_OF_NOTIFICATION_ABOUT_RELAY_ACCORDING_TO_PROPERTIES = 'DATE_OF_NOTIFICATION_ABOUT_RELAY_ACCORDING_TO_PROPERTIES',
  DATE_OF_PROVISION_TO_CORRECT_MISTAKES = 'DATE_OF_PROVISION_TO_CORRECT_MISTAKES',
  DATE_OF_PROVISION_TO_INITIATE_PROCEEDINGS = 'DATE_OF_PROVISION_TO_INITIATE_PROCEEDINGS',
  DATE_OF_PROVISION_TO_LEAVE_WITHOUT_RECOGNITION = 'DATE_OF_PROVISION_TO_LEAVE_WITHOUT_RECOGNITION',
  DATE_OF_PROVISION_TO_REFUSE_INITIATION_OF_PROCEEDINGS = 'DATE_OF_PROVISION_TO_REFUSE_INITIATION_OF_PROCEEDINGS',
  DATE_OF_PROVISION_TO_REFUSE_TO_RESTORE_DATE = 'DATE_OF_PROVISION_TO_REFUSE_TO_RESTORE_DATE',
  DATE_OF_PROVISION_TO_RELAY_ACCORDING_TO_PROPERTIES = 'DATE_OF_PROVISION_TO_RELAY_ACCORDING_TO_PROPERTIES',
  DECISION_AFTER_APPEAL_DATE = 'DECISION_AFTER_APPEAL_DATE',
  DECISION_AFTER_APPEAL_NUMBER = 'DECISION_AFTER_APPEAL_NUMBER',
  DECISION_TO_DISCONTINUE_PROCEEDING_DATE = 'DECISION_TO_DISCONTINUE_PROCEEDING_DATE',
  DECISION_TO_DISCONTINUE_PROCEEDING_NUMBER = 'DECISION_TO_DISCONTINUE_PROCEEDING_NUMBER',
  DECISIONS = 'DECISIONS',
  IS_DELIVERED_BY_ENTITLED_PERSON = 'IS_DELIVERED_BY_ENTITLED_PERSON',
  DELIVERY_DATE = 'DELIVERY_DATE',
  DUPLICATES_CASE_NUMBER = 'DUPLICATES_CASE_NUMBER',
  DUPLICATES_MDOK_UID_NUMBER = 'DUPLICATES_MDOK_UID_NUMBER',
  EPUAP_ADDRESS = 'EPUAP_ADDRESS',
  FAMILY_INCOME_CHANGE_DATE = 'FAMILY_INCOME_CHANGE_DATE',
  IS_UKRAINE = 'IS_UKRAINE',
  MAX_SCHOLARSHIP_EXTENSION_DATE = 'MAX_SCHOLARSHIP_EXTENSION_DATE',
  NEGATIVE_AMENDING_DECISION_DATE = 'NEGATIVE_AMENDING_DECISION_DATE',
  NEGATIVE_AMENDING_DECISION_NUMBER = 'NEGATIVE_AMENDING_DECISION_NUMBER',
  NEGATIVE_DECISION_DATE = 'NEGATIVE_DECISION_DATE',
  NEGATIVE_DECISION_DATE_AFTER_SKO_DECISION = 'NEGATIVE_DECISION_DATE_AFTER_SKO_DECISION',
  NEGATIVE_DECISION_NUMBER = 'NEGATIVE_DECISION_NUMBER',
  OW004_APPEAL_TO_SKO_DATE = 'OW004_APPEAL_TO_SKO_DATE',
  OW004_DECISION_RECEIVE_DATE = 'OW004_DECISION_RECEIVE_DATE',
  OW004_POSITIVE_DECISION_AFTER_SKO_DATE = 'OW004_POSITIVE_DECISION_AFTER_SKO_DATE',
  OW004_POSITIVE_DECISION_AFTER_SKO_NUMBER = 'OW004_POSITIVE_DECISION_AFTER_SKO_NUMBER',
  OW004_NEGATIVE_DECISION_AFTER_SKO_DATE = 'OW004_NEGATIVE_DECISION_AFTER_SKO_DATE',
  OW004_NEGATIVE_DECISION_AFTER_SKO_NUMBER = 'OW004_NEGATIVE_DECISION_AFTER_SKO_NUMBER',
  OW004_NOTICE_OF_DISMISSAL_DATE = 'OW004_NOTICE_OF_DISMISSAL_DATE',
  OW004_NOTICE_OF_FORWARDING_DATE = 'OW004_NOTICE_OF_FORWARDING_DATE',
  OW004_REASSESSMENT_DATE = 'OW004_REASSESSMENT_DATE',
  OW004_REQUEST_FOR_CLARIFICATION_DATE = 'OW004_REQUEST_FOR_CLARIFICATION_DATE',
  OW004_SKO_CANCELLATION_RULING_DATE = 'OW004_SKO_CANCELLATION_RULING_DATE',
  OW004_SKO_CANCELLATION_RULING_NUMBER = 'OW004_SKO_CANCELLATION_RULING_NUMBER',
  OW004_SKO_INADMISSIBILITY_RULING_DATE = 'OW004_SKO_INADMISSIBILITY_RULING_DATE',
  OW004_SKO_INADMISSIBILITY_RULING_NUMBER = 'OW004_SKO_INADMISSIBILITY_RULING_NUMBER',
  OW004_SKO_UPHOLD_RULING_DATE = 'OW004_SKO_UPHOLD_RULING_DATE',
  OW004_SKO_UPHOLD_RULING_NUMBER = 'OW004_SKO_UPHOLD_RULING_NUMBER',
  OW004_SKO_SETTLEMENT_RULING_DATE = 'OW004_SKO_SETTLEMENT_RULING_DATE',
  OW004_SKO_SETTLEMENT_RULING_NUMBER = 'OW004_SKO_SETTLEMENT_RULING_NUMBER',
  OW004_STATEMENT_DATE = 'OW004_STATEMENT_DATE',
  OW004_TERMINATION_DATE = 'OW004_TERMINATION_DATE',
  OW004_WAIVER_DATE = 'OW004_WAIVER_DATE',
  PAYMENT_DATE = 'PAYMENT_DATE',
  POSITIVE_DECISION_DATE = 'POSITIVE_DECISION_DATE',
  POSITIVE_DECISION_DATE_AFTER_SKO_DECISION = 'POSITIVE_DECISION_DATE_AFTER_SKO_DECISION',
  POSITIVE_DECISION_NUMBER = 'POSITIVE_DECISION_NUMBER',
  POSITIVE_DECISION_NUMBER_AFTER_SKO_DECISION = 'POSITIVE_DECISION_NUMBER_AFTER_SKO_DECISION',
  REFUSE_DATE = 'REFUSE_DATE',
  REQUEST_FOR_CLARIFICATION_DATE = 'REQUEST_FOR_CLARIFICATION_DATE',
  REQUEST_TO_COMPLETE_FIX_DATE = 'REQUEST_TO_COMPLETE_FIX_DATE',
  REQUEST_TO_FIX_DATE = 'REQUEST_TO_FIX_DATE',
  REQUEST_TO_FIX_NUMBER = 'REQUEST_TO_FIX_NUMBER',
  RESUME_ACTIONS_DATE = 'RESUME_ACTIONS_DATE',
  SCHOLARSHIP_EXTEND_FORM_DATE = 'SCHOLARSHIP_EXTEND_FORM_DATE',
  SCHOLARSHIP_EXTEND_FORM_NUMBER = 'SCHOLARSHIP_EXTEND_FORM_NUMBER',
  SCHOLARSHIP_GRANT_I_INSTANCE_DECISION_DATE_AFTER_APPEAL = 'SCHOLARSHIP_GRANT_I_INSTANCE_DECISION_DATE_AFTER_APPEAL',
  SCHOLARSHIP_GRANT_I_INSTANCE_DECISION_NUMBER_AFTER_APPEAL = 'SCHOLARSHIP_GRANT_I_INSTANCE_DECISION_NUMBER_AFTER_APPEAL',
  SCHOLARSHIP_GRANT_I_INSTANCE_DECISION_NUMBER_AFTER_SKO_DECISION = 'SCHOLARSHIP_GRANT_I_INSTANCE_DECISION_NUMBER_AFTER_SKO_DECISION',
  SCHOLARSHIP_GRANT_II_INSTANCE_DECISION_NUMBER_AFTER_APPEAL = 'SCHOLARSHIP_GRANT_II_INSTANCE_DECISION_NUMBER_AFTER_APPEAL',
  SCHOLARSHIP_RENEWAL_DECISION_DATE = 'SCHOLARSHIP_RENEWAL_DECISION_DATE',
  SCHOLARSHIP_RENEWAL_DECISION_NUMBER = 'SCHOLARSHIP_RENEWAL_DECISION_NUMBER',
  SCHOLARSHIP_SUSPENSION_DECISION_DATE = 'SCHOLARSHIP_SUSPENSION_DECISION_DATE',
  SCHOLARSHIP_SUSPENSION_DECISION_NUMBER = 'SCHOLARSHIP_SUSPENSION_DECISION_NUMBER',
  SCHOLARSHIP_SUSPENSION_DECISION_FOR_GIVEN_PERIOD_DATE = 'SCHOLARSHIP_SUSPENSION_DECISION_FOR_GIVEN_PERIOD_DATE',
  SCHOLARSHIP_SUSPENSION_DECISION_FOR_GIVEN_PERIOD_NUMBER = 'SCHOLARSHIP_SUSPENSION_DECISION_FOR_GIVEN_PERIOD_NUMBER',
  SCHOLARSHIP_POSITIVE_DECISION_AFTER_APPEAL_NUMBER = 'SCHOLARSHIP_POSITIVE_DECISION_AFTER_APPEAL_NUMBER',
  SCHOLARSHIP_POSITIVE_DECISION_AFTER_APPEAL_DATE = 'SCHOLARSHIP_POSITIVE_DECISION_AFTER_APPEAL_DATE',
  SCHOLARSHIP_WITHDRAWAL_DECISION_FOR_GIVEN_PERIOD_DATE = 'SCHOLARSHIP_WITHDRAWAL_DECISION_FOR_GIVEN_PERIOD_DATE',
  SCHOLARSHIP_WITHDRAWAL_DECISION_FOR_GIVEN_PERIOD_NUMBER = 'SCHOLARSHIP_WITHDRAWAL_DECISION_FOR_GIVEN_PERIOD_NUMBER',
  SCHOLARSHIP_WITHDRAWAL_DECISION_DATE = 'SCHOLARSHIP_WITHDRAWAL_DECISION_DATE',
  SCHOLARSHIP_WITHDRAWAL_DECISION_NUMBER = 'SCHOLARSHIP_WITHDRAWAL_DECISION_NUMBER',
  SCHOOL_CHANGE_INFORM_DATE = 'SCHOOL_CHANGE_INFORM_DATE',
  SEND_APPEAL_WITH_DOCUMENTS_TO_SKO_DATE = 'SEND_APPEAL_WITH_DOCUMENTS_TO_SKO_DATE',
  SKO_DECISION_ABOUT_INADMISSIBILITY_OF_APPEAL_DATE = 'SKO_DECISION_ABOUT_INADMISSIBILITY_OF_APPEAL_DATE',
  SKO_DECISION_TO_DISCONTINUE_APPEAL_DATE = 'SKO_DECISION_TO_DISCONTINUE_APPEAL_DATE',
  SKO_DECISION_TO_REPEAL_OF_DECISION_AND_REFER_TO_I_INSTANCE_DATE = 'SKO_DECISION_TO_REPEAL_OF_DECISION_AND_REFER_TO_I_INSTANCE_DATE',
  SKO_DECISION_TO_REPEAL_OF_DECISION_AND_SETTLEMENT_DATE = 'SKO_DECISION_TO_REPEAL_OF_DECISION_AND_SETTLEMENT_DATE',
  SKO_DECISION_TO_UPHOLD_I_INSTANCE_DECISION_DATE = 'SKO_DECISION_TO_UPHOLD_I_INSTANCE_DECISION_DATE',
  STUDENT_STATUS_EXPLANATION_DATE = 'STUDENT_STATUS_EXPLANATION_DATE',
  SUBMIT_DATE = 'SUBMIT_DATE',
  SUBMIT_DELIVERY_DATE = 'SUBMIT_DELIVERY_DATE',
  TENDERER_DOCUMENT_DATE = 'TENDERER_DOCUMENT_DATE',
  TERMINATION_DATE = 'TERMINATION_DATE',
  TERMINATION_LONG_DATE = 'TERMINATION_LONG_DATE',
  TERMINATION_LONG_NUMBER = 'TERMINATION_LONG_NUMBER',
  TERMINATION_NUMBER = 'TERMINATION_NUMBER',
  TRANSFER_TO_OW_DATE = 'TRANSFER_TO_OW_DATE',
  UPDATED_DELIVERY_DATE = 'UPDATED_DELIVERY_DATE',
  UPDATED_SUBMIT_DATE = 'UPDATED_SUBMIT_DATE',
  SCHOLARSHIP_REINSTATEMENT_DATE = 'SCHOLARSHIP_REINSTATEMENT_DATE'
}

/**
 * Tłumaczenie kodów wartości dokumentu
 *
 * @export
 * @enum {number}
 */
export enum DocumentValueCodesTranslations {
  ADDRESS_EXPLANATION_DATE = 'Data złożenia wyjaśnień dotyczących miejsca zamieszkania',
  AMENDING_DECISION_DATE = 'Data wydania decyzji zmieniającej',
  AMENDING_DECISION_NUMBER = 'Numer decyzji zmieniającej',
  APPEAL_CHANGE_FORM_DATE = 'Data wpływu podania o zmianę formy pomocy materialnej',
  APPEAL_DATE = 'Data wpłynięcia odwołania',
  APPEAL_FOR_HOLD_DATE = 'Data wpłynięcia oświadczenia o ustaniu przyczyn, które stanowiły podstawę przyznania stypendium',
  APPEAL_FOR_RENEWAL_DATE = 'Data wpłynięcia oświadczenia o ustaniu przyczyn, które stanowiły podstawę do wstrzymania stypendium',
  APPEAL_PARENT_DECISION_HOLD_DATE = 'Data wpłynięcia pisma od wnioskodawcy o ustaniu przyczyn, które stanowiły podstawę przyznania stypendium',
  APPEAL_SCHOOL_DECISION_WITHDRAWAL_DATE = 'Data wpłynięcia pisma ze szkoły o ustaniu przyczyn, które stanowiły podstawę przyznania stypendium',
  APPEAL_UNDULY_SCHOLARSHIP_REDEMPTION_DATE = 'Data wpływu pisma o odstąpieniu od żądania zwrotu stypendium',
  BENEFIT_GRANT_I_INSTANCE_DECISION_DATE_AFTER_APPEAL = 'Data wydania decyzji o przyznaniu zasiłku przez organ I instancji po odwołaniu',
  BENEFIT_GRANT_I_INSTANCE_DECISION_DATE_AFTER_SKO_DECISION = 'Data wydania decyzji o przyznaniu zasiłku przez organ I instancji po decyzji SKO',
  BENEFIT_GRANT_I_INSTANCE_DECISION_NUMBER_AFTER_APPEAL = 'Numer decyzji o przyznaniu zasiłku przez organ I instancji po odwołaniu',
  BENEFIT_GRANT_I_INSTANCE_DECISION_NUMBER_AFTER_SKO_DECISION = 'Numer decyzji o przyznaniu zasiłku przez organ I instancji po decyzji SKO',
  BENEFIT_GRANT_II_INSTANCE_DECISION_DATE_AFTER_APPEAL = 'Data wydania decyzji o przyznaniu zasiłku przez organ II instancji po odwołaniu',
  BENEFIT_GRANT_II_INSTANCE_DECISION_NUMBER_AFTER_APPEAL = 'Numer decyzji o przyznaniu zasiłku przez organ II instancji po odwołaniu',
  CERTIFICATE_DATE = 'Data wystawienia zaświadczenia de Minimis',
  CERTIFICATE_NUMBER = 'Numer zaświadczenia de Minimis',
  CHANGE_FORM_DATE = 'Data od której forma pomocy została zmieniona',
  DATE_OF_CONSENT_TO_CHANGE_DECISION = 'Data otrzymania zgody na zmianę decyzji',
  DATE_OF_NOTIFICATION_ABOUT_LEAVING_WITHOUT_RECOGNITION = 'Data zawiadomienia o pozostawieniu bez rozpoznania',
  DATE_OF_NOTIFICATION_ABOUT_PROCEEDING_TERMINATION = 'Data zawiadomienia o zakończeniu postępowania administracyjnego',
  DATE_OF_NOTIFICATION_ABOUT_RELAY_ACCORDING_TO_PROPERTIES = 'Data zawiadomienia o przekazaniu akt zgodnie z właściwością',
  DATE_OF_PROVISION_TO_CORRECT_MISTAKES = 'Data postanowienia o sprostowaniu omyłki/błędu pisarskiego',
  DATE_OF_PROVISION_TO_INITIATE_PROCEEDINGS = 'Data zawiadomienia o wszczęciu postępowania administracyjnego',
  DATE_OF_PROVISION_TO_LEAVE_WITHOUT_RECOGNITION = 'Data wydania postanowienia o pozostawieniu bez rozpoznania',
  DATE_OF_PROVISION_TO_REFUSE_INITIATION_OF_PROCEEDINGS = 'Data wydania postanowienia o odmowie wszczęcia postępowania',
  DATE_OF_PROVISION_TO_REFUSE_TO_RESTORE_DATE = 'Data wydania postanowienia o odmowie przywrócenia terminu',
  DATE_OF_PROVISION_TO_RELAY_ACCORDING_TO_PROPERTIES = 'Data wydania postanowienia o przekazaniu według właściwości',
  DECISION_AFTER_APPEAL_DATE = 'Data wydania decyzji o przyznaniu zasiłku po odwołaniu',
  DECISION_AFTER_APPEAL_NUMBER = 'Numer decyzji o przyznaniu zasiłku po odwołaniu',
  DECISION_TO_DISCONTINUE_PROCEEDING_DATE = 'Data wydania decyzji o umorzeniu postępowania',
  DECISION_TO_DISCONTINUE_PROCEEDING_NUMBER = 'Numer decyzji o umorzeniu postępowania',
  IS_DELIVERED_BY_ENTITLED_PERSON = 'Wniosek złożony przez osobę uprawnioną',
  DELIVERY_DATE = 'Data złożenia/dostarczenia wniosku',
  DUPLICATES_CASE_NUMBER = 'Numer Sprawy w Mdok JO',
  DUPLICATES_MDOK_UID_NUMBER = 'UID dokumentu wniosku z Mdok JO',
  FAMILY_INCOME_CHANGE_DATE = 'Data wpłynięcia oświadczenia o zmianie dochodu rodziny',
  FIX_DATE = 'Data uzupełnienia wniosku',
  IS_UKRAINE = 'Wniosek złożony na ucznia z Ukrainy',
  MAX_SCHOLARSHIP_EXTENSION_DATE = 'Data maksymalnego przedłużenia stypendium',
  NEGATIVE_AMENDING_DECISION_DATE = 'Data wydania decyzji o odmowie zmiany formy stypendium',
  NEGATIVE_AMENDING_DECISION_NUMBER = 'Numer decyzji o odmowie zmiany formy stypendium',
  NEGATIVE_DECISION_DATE = 'Data wydania decyzji odmownej',
  NEGATIVE_DECISION_DATE_AFTER_SKO_DECISION = 'Data wydania decyzji odmownej organu po decyzji SKO',
  NEGATIVE_DECISION_NUMBER = 'Numer decyzji odmownej',
  OW004_APPEAL_TO_SKO_DATE = 'Data złożenia odwołania do SKO',
  OW004_DECISION_RECEIVE_DATE = 'Data odbioru decyzji',
  OW004_POSITIVE_DECISION_AFTER_SKO_DATE = 'Data decyzji pozytywnej po SKO',
  OW004_POSITIVE_DECISION_AFTER_SKO_NUMBER = 'Numer decyzji pozytywnej po SKO',
  OW004_NEGATIVE_DECISION_AFTER_SKO_DATE = 'Data decyzji odmownej po SKO',
  OW004_NEGATIVE_DECISION_AFTER_SKO_NUMBER = 'Numer decyzji odmownej po SKO',
  OW004_NOTICE_OF_DISMISSAL_DATE = 'Data zawiadomienia o pozostawieniu bez rozpatrzenia',
  OW004_NOTICE_OF_FORWARDING_DATE = 'Data zawiadomienia o przekazaniu według właściwości',
  OW004_REASSESSMENT_DATE = 'Data ponownego rozpatrzenia wniosku',
  OW004_REQUEST_FOR_CLARIFICATION_DATE = 'Data wezwania do złożenia wyjaśnień',
  OW004_SKO_CANCELLATION_RULING_DATE = 'Data orzeczeń SKO o uchyleniu i przekazaniu do ponownego rozpatrzenia',
  OW004_SKO_CANCELLATION_RULING_NUMBER = 'Numer orzeczeń SKO o uchyleniu i przekazaniu do ponownego rozpatrzenia',
  OW004_SKO_INADMISSIBILITY_RULING_DATE = 'Data orzeczeń SKO o niedopuszczalności złożenia odwołania',
  OW004_SKO_INADMISSIBILITY_RULING_NUMBER = 'Numer orzeczeń SKO o niedopuszczalności złożenia odwołania',
  OW004_SKO_UPHOLD_RULING_DATE = 'Data orzeczeń SKO o utrzymaniu w mocy',
  OW004_SKO_UPHOLD_RULING_NUMBER = 'Numer orzeczeń SKO o utrzymaniu w mocy',
  OW004_SKO_SETTLEMENT_RULING_DATE = 'Data orzeczeń SKO o rozstrzygnięciu sprawy przez SKO',
  OW004_SKO_SETTLEMENT_RULING_NUMBER = 'Numer orzeczeń SKO o rozstrzygnięciu sprawy przez SKO',
  OW004_STATEMENT_DATE = 'Data złożenia oświadczenia/pisma',
  OW004_TERMINATION_DATE = 'Data zawiadomienia o zakończeniu postępowania administracyjnego',
  OW004_WAIVER_DATE = 'Data złożenia zrzeczenia się prawa do wniesienia odwołania',

  PAYMENT_DATE = 'Data wypłaty',
  POSITIVE_DECISION_DATE = 'Data wydania decyzji pozytywnej',
  POSITIVE_DECISION_DATE_AFTER_SKO_DECISION = 'Data decyzji o przyznaniu stypendium po rozstrzygnięciu SKO',
  POSITIVE_DECISION_NUMBER = 'Numer decyzji pozytywnej',
  POSITIVE_DECISION_NUMBER_AFTER_SKO_DECISION = 'Numer decyzji o przyznaniu stypendium po rozstrzygnięciu SKO',
  REFUSE_DATE = 'Data postanowienia o odmowie wszczęcia postępowania',
  REQUEST_FOR_CLARIFICATION_DATE = 'Data wezwania do złożenia wyjaśnień',
  REQUEST_TO_FIX_DATE = 'Data wezwania do uzupełnienia wniosku',
  REQUEST_TO_FIX_NUMBER = 'Numer wezwania do uzupełnienia/poprawy wniosku',
  RESUME_ACTIONS_DATE = 'Data postanowienie o wznowieniu z urzędu postępowania administracyjnego',
  SCHOLARSHIP_EXTEND_FORM_DATE = 'Data wydania decyzji o rozszerzeniu formy stypendium',
  SCHOLARSHIP_EXTEND_FORM_NUMBER = 'Numer decyzji o rozszerzeniu formy stypendium',
  SCHOLARSHIP_GRANT_I_INSTANCE_DECISION_DATE_AFTER_APPEAL = 'Data wydania decyzji o przyznaniu stypendium przez organ I instancji po odwołaniu',
  SCHOLARSHIP_GRANT_I_INSTANCE_DECISION_NUMBER_AFTER_APPEAL = 'Numer decyzji o przyznaniu stypendium przez organ I instancji po odwołaniu',
  SCHOLARSHIP_GRANT_I_INSTANCE_DECISION_NUMBER_AFTER_SKO_DECISION = 'Numer decyzji o przyznaniu stypendium przez organ I instancji po decyzji SKO',
  SCHOLARSHIP_GRANT_II_INSTANCE_DECISION_NUMBER_AFTER_APPEAL = 'Numer decyzji o przyznaniu stypendium przez organ II instancji po odwołaniu',
  SCHOLARSHIP_REINSTATEMENT_DATE = 'Data przywrócenia stypendium',
  SCHOLARSHIP_RENEWAL_DATE = 'Data wznowienia stypendium',
  SCHOLARSHIP_RENEWAL_DECISION_DATE = 'Data wydania decyzji o wygaśnięciu wstrzymania stypendium szkolnego',
  SCHOLARSHIP_RENEWAL_DECISION_NUMBER = 'Numer decyzji o wygaśnięciu wstrzymania stypendium szkolnego',
  SCHOLARSHIP_SUSPENSION_DATE = 'Data wstrzymania stypendium',
  SCHOLARSHIP_SUSPENSION_DECISION_DATE = 'Data wydania decyzji o wstrzymaniu stypendium',
  SCHOLARSHIP_SUSPENSION_DECISION_NUMBER = 'Numer decyzji o wstrzymaniu stypendium',
  SCHOLARSHIP_SUSPENSION_DECISION_FOR_GIVEN_PERIOD_DATE = 'Data wydania decyzji o wstrzymaniu stypendium na dany okres',
  SCHOLARSHIP_SUSPENSION_DECISION_FOR_GIVEN_PERIOD_NUMBER = 'Numer decyzji o wstrzymaniu stypendium na dany okres',
  SCHOLARSHIP_POSITIVE_DECISION_AFTER_APPEAL_NUMBER = 'Numer decyzji o przyznaniu stypendium po odwołaniu',
  SCHOLARSHIP_POSITIVE_DECISION_AFTER_APPEAL_DATE = 'Data decyzji o przyznaniu stypendium po odwołaniu',
  SCHOLARSHIP_WITHDRAWAL_DATE = 'Data cofnięcia stypendium',
  SCHOLARSHIP_WITHDRAWAL_DECISION_FOR_GIVEN_PERIOD_DATE = 'Data decyzji o cofnięciu stypendium na dany okres',
  SCHOLARSHIP_WITHDRAWAL_DECISION_DATE = 'Data wydania decyzji o cofnięciu stypendium',
  SCHOLARSHIP_WITHDRAWAL_DECISION_NUMBER = 'Numer decyzji o cofnięciu stypendium',
  SCHOLARSHIP_WITHDRAWAL_DECISION_FOR_GIVEN_PERIOD_NUMBER = 'Numer decyzji o cofnięciu stypendium na dany okres',
  SCHOOL_CHANGE_INFORM_DATE = 'Data wpłynięcia pisma informującego o zmianie szkoły',
  SEND_APPEAL_WITH_DOCUMENTS_TO_SKO_DATE = 'Data przesłania odwołania wraz z aktami do SKO',
  SKO_DECISION_ABOUT_INADMISSIBILITY_OF_APPEAL_DATE = 'Data wydania rozstrzygnięcia przez SKO - Stwierdzenie niedopuszczalności odwołania',
  SKO_DECISION_TO_DISCONTINUE_APPEAL_DATE = 'Data wydania rozstrzygnięcia przez SKO - Umorzenie postępowania odwoławczego',
  SKO_DECISION_TO_REPEAL_OF_DECISION_AND_REFER_TO_I_INSTANCE_DATE = 'Data wydania rozstrzygnięcia przez SKO - Uchylenie decyzji i skierowanie do I instancji celem ponownego rozpatrzenia',
  SKO_DECISION_TO_REPEAL_OF_DECISION_AND_SETTLEMENT_DATE = 'Data wydania rozstrzygnięcia przez SKO - Uchylenie decyzji i wydanie rozstrzygnięć przez SKO',
  SKO_DECISION_TO_UPHOLD_I_INSTANCE_DECISION_DATE = 'Data wydania rozstrzygnięcia przez SKO - Utrzymanie w mocy decyzji organu I instancji',
  STUDENT_STATUS_EXPLANATION_DATE = 'Data złożenia wyjaśnień dotyczących skreślenia z listy uczniów szkoły',
  SUBMIT_DATE = 'Data zapisania wniosku w systemie',
  TERMINATION_DATE = 'Data postanowienia o zakończeniu postępowania administracyjnego (krótkie)',
  TERMINATION_LONG_DATE = 'Data postanowienia o zakończeniu postępowania administracyjnego po wezwaniu (długie)',
  TERMINATION_LONG_NUMBER = 'Numer postanowienia o zakończeniu postępowania administracyjnego po wezwaniu (długie)',
  TERMINATION_NUMBER = 'Numer postanowienia o zakończeniu postępowania administracyjnego (krótkie)',
  TENDERER_DOCUMENT_DATE = 'Data wpływu pisma od wnioskodawcy',
  TRANSFER_TO_OW_DATE = 'Wysłanie do OW',
  UPDATED_DELIVERY_DATE = 'Data dostarczenia uzupełnienia wniosku po wezwaniu',
  UPDATED_SUBMIT_DATE = 'Złożenie po poprawie'
}
